/**
 * Validates a Hungarian tax number (adószám)
 * Format: 12345678-1-23 (8 digits - 1 digit - 2 digits)
 * @param taxNumber 
 * @returns 
 */
export const validateTaxNumber = (taxNumber: string): boolean => {
  // Regex pattern for Hungarian tax number format: 12345678-1-23
  const taxNumberPattern = /^\d{8}-\d{1}-\d{2}$/;
  return taxNumberPattern.test(taxNumber);
};

/**
 * Validates a Hungarian company registration number (cégjegyzékszám)
 * Format: 01-10-123456 (2 digits - 2 digits - 6 digits)
 * @param regNumber 
 * @returns 
 */
export const validateRegistrationNumber = (regNumber: string): boolean => {
  // Regex pattern for Hungarian company registration number format: 01-10-123456
  const regNumberPattern = /^\d{2}-\d{2}-\d{6}$/;
  return regNumberPattern.test(regNumber);
};

/**
 * Formats a tax number input to match the Hungarian tax number format
 * @param input 
 * @returns 
 */
export const formatTaxNumber = (input: string): string => {
  // Remove all non-digits
  const digitsOnly = input.replace(/\D/g, '');
  
  // If we have 11 digits, format as 12345678-1-23
  if (digitsOnly.length <= 11) {
    // Handle partial input based on current length
    if (digitsOnly.length <= 8) {
      return digitsOnly;
    } else if (digitsOnly.length <= 9) {
      return `${digitsOnly.slice(0, 8)}-${digitsOnly.slice(8)}`;
    } else {
      return `${digitsOnly.slice(0, 8)}-${digitsOnly.slice(8, 9)}-${digitsOnly.slice(9)}`;
    }
  }
  
  // If we have more than 11 digits, truncate and format
  return `${digitsOnly.slice(0, 8)}-${digitsOnly.slice(8, 9)}-${digitsOnly.slice(9, 11)}`;
};

/**
 * Formats a registration number input to match the Hungarian company registration format
 * @param input 
 * @returns 
 */
export const formatRegistrationNumber = (input: string): string => {
  // Remove all non-digits
  const digitsOnly = input.replace(/\D/g, '');
  
  // If we have 10 digits, format as 01-10-123456
  if (digitsOnly.length <= 10) {
    // Handle partial input based on current length
    if (digitsOnly.length <= 2) {
      return digitsOnly;
    } else if (digitsOnly.length <= 4) {
      return `${digitsOnly.slice(0, 2)}-${digitsOnly.slice(2)}`;
    } else {
      return `${digitsOnly.slice(0, 2)}-${digitsOnly.slice(2, 4)}-${digitsOnly.slice(4)}`;
    }
  }
  
  // If we have more than 10 digits, truncate and format
  return `${digitsOnly.slice(0, 2)}-${digitsOnly.slice(2, 4)}-${digitsOnly.slice(4, 10)}`;
}; 